import {
    DELETE_CUSTOMER_REQUEST,
    DELETE_CUSTOMER_SUCCESS,
    DELETE_CUSTOMER_FAILURE,
    RESET_DELETE_CUSTOMER_STATE
} from '../actions/delete-customer-actions';

const initialState = {
    isDeleted: false,
    isLoading: false,
    error: null,
};

export default function deleteCustomerReducer(state = initialState, action) {
    switch (action.type) {
        case DELETE_CUSTOMER_REQUEST:
            return { ...state, isLoading: true, error: null, isDeleted: false };
        case DELETE_CUSTOMER_SUCCESS:
            return { ...state, isLoading: false, isDeleted: true };
        case DELETE_CUSTOMER_FAILURE:
            return { ...state, isLoading: false, error: action.payload, isDeleted: false };
        case RESET_DELETE_CUSTOMER_STATE:
            return initialState;
        default:
            return state;
    }
}